import { Pipe, PipeTransform } from '@angular/core';
import { WarningStatusDetails } from '@dpr-details/enums';
import { DprActivityGridData } from '@dpr-details/models/grid';

@Pipe({ name: 'warningStatusIcon' })
export class WarningStatusIconPipe implements PipeTransform {
  transform(data: DprActivityGridData): string {
    return data?.status ? WarningStatusDetails.get(data.status)?.icon : null;
  }
}
